/**
 * @name PasswordService
 * @description Servicio para la gestión de contraseñas
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Restablece contraseña de usuario
 * @param {object} request { IdUsuario: number, Token: string, ContraseñaNueva: string, ConfirmarContraseña: string }
 * @return {any} promise
 */
const restore = (request) => {
  let URL = `${BASE_URL}/Usuario/RestablecerContrasena`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Recibe un objeto con el nombre de usuario para solicitar envío de correo electrónico para recuperación de contraseña
 * @param {any} request { Usuario: string }
 * @return {any} promise
 */
const retrieve = (request) => {
  let URL = `${BASE_URL}/Usuario/PeticionContrasena`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Cambia la contraseña del usuario
 * @param request { ContraseñaAnterior: string, ContraseñaNueva: string, ConfirmarContraseña: string } 
 * @return {any} promise
 */
const postPass = (request) => {
  let URL = `${BASE_URL}/Usuario/CambiarContrasena/`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Cambiar contraseña de varios colaboradores como administrador
 * @param {object} request { IdsEmpleado: [number], ContraseñaNueva: string, ConfirmarContraseña: string }
 * @return {any} promise
 */
const changeMassive = (request) => {
  let URL = `${BASE_URL}/Empleado/Contrasena`;

  return axios.put(URL, request).then(() => {
    // ResponseHandlerService.callBack
  });
};

/**
 * Recibe un objeto con el nombre de usuario para solicitar envío de correo electrónico para desbloquear al usuario
 * @param {any} request
 * @return {any} promise
 */
const unlock = (request) => {
  let URL = `${BASE_URL}/Empleado/CorreoDesbloqueo`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Recibe un objeto con el nombre de usuario para solicitar envío de correo electrónico para desbloquear al usuario
 * @param {any} request
 * @return {any} promise
 */
const unlockUser = (request) => {
  let URL = `${BASE_URL}/Empleado/Desbloqueo?IdEmpresa=${request.IdEmpresa}&IdEmpleado=${request.IdEmpleado}`;

  return axios.put(URL).then(({ data }) => {
    return data;
  });
};

export const PasswordService = {
  restore,
  retrieve,
  postPass,
  changeMassive,
  unlock,
  unlockUser
};